import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-mobile-contracts',
  templateUrl: './mobile-contracts.component.html',
  styleUrls: ['./mobile-contracts.component.scss', '../service-pages.component.scss']
})
export class MobileContractsComponent implements OnInit {
  faq!: any[];

  constructor(private tSrv: Title) { }

  ngOnInit(): void {
    this.tSrv.setTitle('Broadband Contracts | Services | Don\'t Waste Money');
    this.initialiseState();
  }

  initialiseState() {
    this.faq = [
      { title: 'Can I save money by switching my broadband and phone contract to a different supplier?', body: 'By switching your broadband contract you can make savings every month that add up across the year. Our dedicated team will find out exactly how much you’re overpaying and find the contract for you based on what you actually you use your broadband for. Our experts will then do all the hard work and switch your contract over for you'},
      { title: 'Can I get a broadband contract if I have a bad credit rating?', body: 'There are options for people with bad credit looking to get a broadband contract, however these depend on what contract and device you are looking for. However, it is important that you work on improving your credit score as this can open up more opportunties to save money with other suppliers.' }
    ];
  }
}
